import { CodebookModel } from 'app/shared/model/shared.model';

export interface CaseConstructionLegalityModel {
  plotConstructionAndProofOfLegality: boolean;
  existingBuildingRatio: CodebookModel[];
}

export const caseConstructionLegalityInitial: CaseConstructionLegalityModel = {
  existingBuildingRatio: [],
  plotConstructionAndProofOfLegality: false
}

export interface CaseConstructionLegalityDocumentAddFormModel {
  idCaseConstructionLegalityDocumentMap?: string;
  webId: string;
  finalActDocumentName: string;
  classification: string;
  finalActFileNumber: string;
  finalDocumentAdmissionDate?: Date;
  solutionType: string;
  executionDate?: Date;
  effectivenessDate?: Date;
  dataFetched: boolean;
  authority: string;
  administrativeUnit: string;
  authorityOfficeOldName: string;
}

export const caseConstructionLegalityDocumentAddFormInitial = {
  webId: '',
  finalActDocumentName: '',
  classification: '',
  finalActFileNumber: '',
  finalDocumentAdmissionDate: null,
  solutionType: '',
  executionDate: null,
  effectivenessDate: null,
  dataFetched: false,
} as CaseConstructionLegalityDocumentAddFormModel;

export interface CaseConstructionLegalityDocumentsPage {
  totalElements: number;
  content: CaseConstructionLegalityDocumentAddFormModel[];
}
